import React, { useEffect, useState } from "react";
import {
  FaChalkboardUser,
  FaChurch,
  FaLocationDot,
  FaSchool,
  FaSpinner,
} from "react-icons/fa6";
import { LiaTimesCircle } from "react-icons/lia";
import {
  allTrainingClasses,
  capitalizeEachWord,
  classRegistration,
  cleanName,
  getCentresDirect,
  getFreeTeachers,
} from "../../AppManager";
import { useNavigate, useOutletContext } from "react-router-dom";

function AddClass() {
  const { record, setRecord } = useOutletContext();
  const [formData, setFormData] = useState({
    centre: "",
    trainingClass: "",
    name: "",
    teacher: "",
    assistant: "",
    location: "",
  });
  const [centres, setCentres] = useState([]);
  const [status, setStatus] = useState({
    status: "",
    type: "",
    message: "",
  });
  const [uploading, setUploading] = useState(false);
  const [teachers, setTeachers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    getFreeTeachers()
      .then((data) => setTeachers(data))
      .catch((err) => err);
  }, []);

  function handleChange(e) {
    const { name, value } = e.target;
    setFormData((oldFormData) => ({
      ...oldFormData,
      [name]: name === "name" ? cleanName(capitalizeEachWord(value)) : value,
    }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      setUploading(true);
      const regData = {
        name: formData.name,
        centre: formData.centre,
        trainingClass: formData.trainingClass,
        teacher: formData.teacher,
        assistant: formData["assistant"],
        location: formData.location,
      };
      const res = await classRegistration(regData);
      if (res === "Exists") {
        setStatus({
          status: "exists",
          type: "failed",
          message: "Class already Exists",
        });
        setUploading(false);
        return null;
      } else if (res === "Teacher") {
        setStatus({
          status: "Teacher",
          type: "failed",
          message: "Teacher already assigned to a Class",
        });
        setUploading(false);
      } else if (res === "NTeacher") {
        setStatus({
          status: "Teacher",
          type: "failed",
          message: "Teacher not Found",
        });
        setUploading(false);
      } else if (res === "Assistant") {
        setStatus({
          status: "Assistant",
          type: "failed",
          message: "Assistant already assigned to a Class",
        });
        setUploading(false);
      } else if (res === "NAssistant") {
        setStatus({
          status: "Assistant",
          type: "failed",
          message: "Assistant not Found",
        });
        setUploading(false);
      } else if (res === "Registered") {
        const newClass = {
          name: formData.name,
          teacher: formData.teacher,
          assistant: formData["assistant"],
          students: "0",
          admission: true,
          currentClass: true,
          location: formData.location,
        };
        const newClasses =
          record[formData.centre][formData.trainingClass] &&
          record[formData.centre][formData.trainingClass].classes
            ? [...record[formData.centre][formData.trainingClass].classes]
            : [];
        newClasses.push(newClass);

        setRecord((oldRecord) => {
          return {
            ...oldRecord,
            [formData.centre]: {
              ...oldRecord[formData.centre],
              [formData.trainingClass]: {
                ...oldRecord[formData.centre][formData.trainingClass],
                classes: newClasses,
              },
            },
          };
        });

        setTimeout(() => {
          setStatus({
            status: "success",
            type: "success",
            message: "Class Created. Redirecting...",
          });
          setTimeout(() => {
            navigate(`/admin/overview/classes/${formData.name}`, {
              replace: true,
            });
          }, 2000);
        }, 1000);
      } else {
        setStatus({
          status: "error",
          type: "failed",
          message: "Class Creation Failed",
        });
        setUploading(false);
        return null;
      }
    } catch (error) {
      setStatus({
        status: "error",
        type: "failed",
        message: "Creation Failed",
      });
      setUploading(false);
    }
  }

  useEffect(() => {
    if (status.message !== "") {
      document
        .getElementById("status-wrapper")
        .scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [status]);

  useEffect(() => {
    getCentresDirect()
      .then((data) => setCentres(data))
      .catch((err) => err);
  }, []);

  document.title = "Add Class";

  const centreElem = centres.map((centre) => (
    <option key={centre} value={centre}>
      {centre}
    </option>
  ));
  const selectTclasses = allTrainingClasses.map((tclass) => (
    <option key={tclass} value={tclass}>
      {tclass}
    </option>
  ));

  return (
    <div className="formwrapper" style={{ margin: "50px 0" }}>
      <div className="wrapper">
        <div className="form-box login">
          <h2>Add Class</h2>
          <form onSubmit={handleSubmit}>
            {status.message !== "" && (
              <p className="status-wrapper" id="status-wrapper">
                <span className={`status-message ${status.type}`}>
                  {status.message}
                </span>
                <LiaTimesCircle
                  className="status-close"
                  onClick={() => {
                    setStatus({ status: "", type: "", message: "" });
                  }}
                />
              </p>
            )}
            <div className="input-box">
              <span className="icon">
                <FaSchool />
              </span>
              <input
                readOnly={uploading}
                type="text"
                onChange={handleChange}
                value={formData.name}
                autoComplete="off"
                required
                pattern="[A-Za-z\- ]+"
                name="name"
                placeholder=" "
                minLength={10}
                maxLength={50}
              />
              <label>Class Name</label>
            </div>
            <div className="input-box">
              <select
                disabled={uploading}
                name="centre"
                className="inputs"
                required
                onChange={handleChange}
                value={formData.centre}
              >
                <option value="" disabled>
                  Choose one...
                </option>
                {centreElem}
              </select>
              <label>
                <FaChurch /> Centre
              </label>
            </div>
            <div className="input-box">
              <select
                disabled={uploading}
                name="trainingClass"
                value={formData.trainingClass}
                onChange={handleChange}
                className="inputs"
                required
              >
                <option value="" disabled>
                  Choose one...
                </option>
                {selectTclasses}
              </select>
              <label>
                <FaSchool /> Training Class
              </label>
            </div>
            <div className="input-box">
              <span className="icon">
                <FaLocationDot />
              </span>
              <input
                readOnly={uploading}
                type="text"
                onChange={handleChange}
                value={formData.location}
                autoComplete="off"
                required
                pattern="[A-Za-z0-9\- ]+"
                title="Accepts only Alphabets, Numbers and Space"
                name="location"
                placeholder=" "
                minLength={3}
                maxLength={50}
              />
              <label>Location</label>
            </div>
            <div className="input-box">
              <select
                disabled={uploading}
                name="teacher"
                value={formData.teacher}
                onChange={handleChange}
                className="inputs"
              >
                <option value="">None Assigned</option>
                {teachers.map((teacher) => (
                  <option
                    value={teacher["matric"]}
                    key={teacher["matric"] + " teacher"}
                  >
                    {teacher["name"]} - {teacher["matric"]}
                  </option>
                ))}
              </select>
              <label>
                <FaChalkboardUser /> Teacher
              </label>
            </div>
            <div className="input-box">
              <select
                disabled={uploading}
                name="assistant"
                value={formData.assistant}
                onChange={handleChange}
                className="inputs"
              >
                <option value="">None Assigned</option>
                {teachers.map((teacher) => (
                  <option
                    value={teacher["matric"]}
                    key={teacher["matric"] + " assistant"}
                  >
                    {teacher["name"]} - {teacher["matric"]}
                  </option>
                ))}
              </select>
              <label>
                <FaChalkboardUser /> Assistant Teacher
              </label>
            </div>
            <button type="submit" disabled={uploading} className="btn">
              {uploading ? <FaSpinner className="spinner" /> : "Create"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddClass;
